import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, FormControl, FormGroup } from '@angular/forms';
import { Pessoa } from '@tivic-team/manager-ts/dist/grl';
import { PessoaDTO } from 'app/model/dtos/grl/pessoa.dto';
import { PessoaService } from 'app/services/grl/pessoa.service';
import { ConcessaoSearch } from 'app/services/mob/concessao.search';
import { ConcessaoService } from 'app/services/mob/concessao.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ElementRef } from 'sol-request-angular/node_modules/@angular/core';

@Component({
  selector: 'autocomplete-find-concessionario',
  templateUrl: './autocomplete-find-concessionario.component.html',
  styleUrls: ['./autocomplete-find-concessionario.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class AutocompleteFindConcessionarioComponent implements OnInit {
  @Input() formGroup: FormGroup;

  concessionarios: Pessoa[];
  concessionariosFiltrados: Pessoa[];
  @ViewChild("cdPessoa", { static: false }) cdPessoa: ElementRef;


  constructor(
    private _concessaoService: ConcessaoService,
    private _pessoaService: PessoaService,
    private _controlContainer: ControlContainer,
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup
    this.formGroup.addControl("pessoa", new FormControl());
    this.formGroup.get("pessoa").valueChanges.pipe(
      switchMap((value) => {
        if (value && typeof value === "string" && value.length > 2) {
          return this._concessaoService.findNomeConcessionarioColetivoUrbano(
            new ConcessaoSearch({ nmConcessionario: value })
          );
        } else {
          return of(null);
        }
      })
    ).subscribe((concessionarios) => (this.concessionariosFiltrados = concessionarios));
  }

  async ngAfterViewInit() {
      this.formGroup.get('cdPessoa').valueChanges
        .pipe(
          switchMap(async (cdPessoa) => {
            if (!cdPessoa)
              return;
            let pessoa: PessoaDTO = await this._pessoaService.get(cdPessoa);
            this.formGroup.patchValue(pessoa, {emitEvent: false});
            this.cdPessoa.nativeElement.value = pessoa.nmPessoa;
            await this.pessoaSelecionada({option: {value: pessoa}});
            return of(null);
          })
        )
        .subscribe();
  }
  
  displayFn(concessionario: Pessoa) {
    if (concessionario) {
      return concessionario.nmPessoa;
    }
  }

  async pessoaSelecionada($event) {
    let pessoaSelecionada = $event.option.value;
    this.formGroup.get("cdPessoa").setValue(pessoaSelecionada.cdPessoa, {emitEvent: false});
  }
}
